<template>
  <div>

    <vx-card card-border class="mb-4" title="Documentación asociada a la operación" title-color="dark" collapseAction>
      <vx-card card-border class="mb-2" v-for="(documento, index) in documentos" :key="index">

          <vs-row>
            <vs-col vs-type="flex" vs-align="center" vs-w="4">
              <span class="text-lg"> {{ documento.fichero }} </span>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-chip v-if="documento.valTipoDocumento !== undefined" color="warning">{{documento.valTipoDocumento.nombre}}</vs-chip>
            </vs-col>
            <vs-col vs-type="flex" vs-align="center" vs-w="3">
              <p>{{documento.descripcion}}</p>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
              <feather-icon class="mr-4 hover:text-primary cursor-pointer" @click="descargaDocumento(documento.id, documento.fichero)" icon="DownloadIcon"/>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="1">
              <feather-icon icon="Trash2Icon" class="mr-4 hover:text-primary cursor-pointer" @click="confirmarBorrarDocumento(index, documento.id, documento.fichero)"/>
            </vs-col>
          </vs-row>       

      </vx-card>
      <div class="vx-row w-full" v-if="documentos === undefined || documentos.length === 0">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No existe ningún documento asociado a esta operación.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <vx-card card-border class="mb-2" title="Añadir nuevos documentos" title-color="dark" collapseAction>
      <div class="vx-row mb-4" v-for="(documento, index) in fileRecordsForUpload" :key="index">
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span>Nombre del fichero:</span>
          </div>
          <div>
            <vs-input class="w-full" name="fichero" v-model="fileRecordsForUpload[index].file.name" disabled />
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span>Tipo documento:</span>
          </div>
          <div>
            <v-select class="w-full" 
              v-model="fileRecordsForUpload[index].tipoDocumento" 
              :options="valTiposDocumentos" 
              label="nombre"
              :reduce="id => id.id" 
            />
          </div>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <div>
            <span>Descripción:</span>
          </div>
          <div>
            <vs-input class="w-full" name="descripcion" v-model="fileRecordsForUpload[index].descripcion" @input="v => { fileRecordsForUpload[index].descripcion = v.toUpperCase()}"/>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <VueFileAgent 
            ref="vueFileAgent"
            v-model="fileRecords"
            :deletable="true"
            :helpText="'Seleccione ficheros'"
            @select="vueFileAgentFilesSelected($event)"
            @beforedelete="vueFileAgentOnBeforeDelete($event)"
            @delete="vueFileAgentFileDeleted($event)"
          ></VueFileAgent>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="guardar" :disabled="!validateForm">Guardar</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Cancelar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import valTiposDocumentosStore from '@/store/configuracion/val-tipos-documentos/index.js'
import documentosStore from '@/store/gestion/documentos/index.js'

import Vue from 'vue'
import axios from '@/axios.js'

import vSelect from 'vue-select'

// Carga de ficheiros
import VueFileAgent from 'vue-file-agent'
Vue.use(VueFileAgent)
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'

import VueLink from 'vue-link'

export default {
  name: 'OperacionesEditDocumentacion',
  components: {
    VueFileAgentStyles,
    VueLink,
    vSelect
  },
  props: {

  },
  data () {
    return {
      operacion: {},
      documentos: [],
      valTiposDocumentos: [],
      // VueFileAgent
      fileRecords: [],
      fileRecordsForUpload: []
    }
  },
  computed: {
    validateForm () {
      if (this.fileRecordsForUpload.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    showSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showError (titulo, error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: titulo,
        text: error
      })
    },
    reset_data () {
      this.$router.push({name: 'operaciones'})
    },
    async descargaDocumento (id, nombre) {
      await this.$store.dispatch('documentosStore/downloadDocumento', id)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', nombre)
          document.body.appendChild(link)
          link.click()
        })
        .catch((error) => {
          console.log('ERROR', error)
        })
    },
    vueFileAgentDeleteUploadedFile (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord)
    },
    vueFileAgentFilesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
    },
    vueFileAgentOnBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
      }
    },
    vueFileAgentFileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        this.fileRecords.splice(i, 1)
      } else {
        this.vueFileAgentDeleteUploadedFile(fileRecord)
      }
    },
    confirmarBorrarDocumento (index, id, documento) {
      this.documento = { index, id }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ATENCIÓN: no se podrá recuperar!',
        text: `¿Seguro que desea eliminar el documento "${documento}"?`,
        accept: this.borrarDocumento,
        acceptText: 'Eliminar'
      })
    },
    borrarDocumento () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      return new Promise((resolve, reject) => {
        axios.delete(`/api/documentos/${this.documento.id}`)
          .then(() => {
            this.documentos.splice(this.documento.index, 1)
            this.inicializar('DOCUMENTO ELIMINADO', 'El documento ha sido eliminado correctamente.')
          })
          .catch((error) => {
            this.showError('ERROR AL ELIMINAR EL DOCUMENTO', error)
            reject(error)
          })
      })
    },
    async guardar () {
      if (!this.validateForm) return
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      
      const formData = new FormData()
      const datos = []

      // Revisamos se hai ficheiros para subir
      if (Array.isArray(this.fileRecordsForUpload) && this.fileRecordsForUpload.length > 0) {
        this.fileRecordsForUpload.forEach(element => {  // recorremos os ficheiros a subir
          datos.push(JSON.stringify({
            'operacionId': this.operacion.id, 
            'nombreFichero': element.file.name, 
            'tipoDocumento': element.tipoDocumento === undefined ? null : element.tipoDocumento, 
            'descripcion': element.descripcion === undefined ? null : element.descripcion,
            'categoria': 'operacion'
          }))
          formData.append('ficheiros[]', element.file)    // gardamos o ficheiro físico para enviar
        })
      }
      formData.append('datos[]', datos)

      await this.$store.dispatch('documentosStore/addDocumentos', formData)
        .then(() => {
          this.inicializar('DOCUMENTOS GUARDADOS', 'Los documentos han sido guardados correctamente.')
        })
        .catch((error) => {
          this.showError('ERROR GUARDANDO DOCUMENTOS', error)
        })
    },
    async inicializar (titulo, texto) {
      this.fileRecords = []
      this.fileRecordsForUpload = []

      /**
       * Cando gardamos ou eliminamos un documento debemos lanzar a función que actualiza a porcentaxe completada da operación
       */
      await this.$store.dispatch('operacionesStore/actualizarPorcentajeCompletado', this.operacion.id)
        .then()
        .catch((error) => {
          console.error(error)         
        })

      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then((response) => {
          this.operacion = response.data
          this.documentos = JSON.parse(JSON.stringify(this.operacion.documentos))
          this.showSuccess(titulo, texto)
        })
        .catch((error) => {
          this.showError('ERROR ACTUALIZANDO DATOS', error)
        })

      // Lanzamos o emit para que se actualice a barra de progreso de porcentaxe completado da operación     
      this.$emit('actualizar-barra-porcentaje-completado')  
    }
  },
  async created () {
    this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!valTiposDocumentosStore.isRegistered) {
      this.$store.registerModule('valTiposDocumentosStore', valTiposDocumentosStore)
      valTiposDocumentosStore.isRegistered = true
    }
    if (!documentosStore.isRegistered) {
      this.$store.registerModule('documentosStore', documentosStore)
      documentosStore.isRegistered = true
    }

    await this.$store.dispatch('valTiposDocumentosStore/getTiposDocumentos')
      .then(() => {
        // Recorremos os tipo de documentos e se están activos engadímolas ao combo
        this.$store.state.valTiposDocumentosStore.tiposDocumentos.forEach(element => {
          if (element.activo && element.categoria === 'OPERACION') this.valTiposDocumentos.push(element)
        })
      })
      .catch((error) => {
        console.log(error)
      })
    
    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.documentos = JSON.parse(JSON.stringify(this.operacion.documentos))

    this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
  }
}
</script>

